import { Resource } from "../resource/resource.model";

/**
 * Users WITHIN a tenant in 4Comply.  This will be used in both applications
 */

export class ClientEmailTemplate extends Resource {
  createdAt: Date;
  footer: string;
  hydratedTemplate: string;
  subject: string;
  template: string;
  type: string;
  updatedAt: Date;
}
